import { createBrowserRouter } from "react-router";
import { Layout } from "./Layout";
import { InboxScreen } from "./screens/InboxScreen";
import { SearchScreen } from "./screens/SearchScreen";
import { UsersScreen } from "./screens/UsersScreen";
import { StatsScreen } from "./screens/StatsScreen";
import { SettingsScreen } from "./screens/SettingsScreen";
import { LoginScreen } from "./screens/LoginScreen";

export const router = createBrowserRouter([
  {
    path: "/login",
    Component: LoginScreen,
  },
  {
    path: "/",
    Component: Layout,
    children: [
      { index: true, Component: InboxScreen },
      { path: "search", Component: SearchScreen },
      { path: "users", Component: UsersScreen },
      { path: "stats", Component: StatsScreen },
      { path: "settings", Component: SettingsScreen },
    ],
  },
]);
